/**
 * Kron — Klaviyo Newsletter Bridge
 *
 * Captura submits dos forms de newsletter (popup nativo + footer),
 * envia o email pra Klaviyo Subscribe API client-side (public key),
 * depois libera o submit nativo Shopify pra criar o customer com accepts_marketing.
 *
 * IMPORTANTE: precisamos AGUARDAR o fetch Klaviyo completar antes de deixar
 * o form Shopify navegar — senão o CORS preflight é cancelado pela navegação
 * e o request nunca chega na Klaviyo.
 *
 * Public key e List IDs são SEGUROS de expor (projetados pra uso client-side).
 */
(() => {
  const COMPANY_ID = 'QYeekH';
  const LIST_BY_SOURCE = {
    'Newsletter Popup':  'SpNuxm',  // "Kron inscritos pop up"
    'Newsletter Footer': 'U34d7m',  // "Email List"
    'Newsletter Form':   'U34d7m',
  };
  const REVISION = '2025-10-15';
  const ENDPOINT = `https://a.klaviyo.com/client/subscriptions/?company_id=${COMPANY_ID}`;
  const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const TIMEOUT_MS = 4000;
  const PASSED_FLAG = '__kronKlaviyoSent';
  const LOG = (...args) => console.log('[kron-klaviyo]', ...args);

  function isNewsletterForm(form) {
    if (!form || form.tagName !== 'FORM') return false;
    if (/^newsletter-/.test(form.id || '')) return true;
    if (form.querySelector('input[name="contact[tags]"][value*="newsletter"]')) return true;
    if (form.closest('newsletter-popup')) return true;
    return false;
  }

  function getEmail(form) {
    const input = form.querySelector('input[name="contact[email]"], input[type="email"]');
    return input ? input.value.trim() : null;
  }

  function getSource(form) {
    if (form.closest('newsletter-popup')) return 'Newsletter Popup';
    if (form.closest('footer')) return 'Newsletter Footer';
    return 'Newsletter Form';
  }

  function subscribe(email, source) {
    const listId = LIST_BY_SOURCE[source] || LIST_BY_SOURCE['Newsletter Form'];
    const body = JSON.stringify({
      data: {
        type: 'subscription',
        attributes: {
          custom_source: source,
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email,
                subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } },
              },
            },
          },
        },
        relationships: { list: { data: { type: 'list', id: listId } } },
      },
    });
    const ctrl = new AbortController();
    const timer = setTimeout(() => ctrl.abort(), TIMEOUT_MS);
    return fetch(ENDPOINT, {
      method: 'POST',
      mode: 'cors',
      headers: { 'Content-Type': 'application/json', revision: REVISION },
      body,
      signal: ctrl.signal,
    }).then(r => {
      clearTimeout(timer);
      LOG('subscribe response', r.status, '→ list', listId);
      return r;
    }).catch(err => {
      clearTimeout(timer);
      LOG('subscribe failed', err?.name || err);
    });
  }

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!isNewsletterForm(form)) return;
    if (form[PASSED_FLAG]) return; // já processado, deixa o submit nativo seguir
    const email = getEmail(form);
    if (!email || !EMAIL_RE.test(email)) return;

    const source = getSource(form);
    LOG('intercept', { source, email });

    // Segura o submit nativo até o Klaviyo responder (ou timeout 4s)
    event.preventDefault();
    event.stopPropagation();

    subscribe(email, source).finally(() => {
      form[PASSED_FLAG] = true;
      LOG('releasing native submit');
      // submit() programatico não dispara listeners — segue direto pro POST nativo
      form.submit();
    });
  }, true);

  LOG('bridge loaded — popup→SpNuxm, footer→U34d7m');
})();
